<div class="progress progress-modal">
  <div
    class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
    role="progressbar"
    style="width: 100%"
    aria-valuenow="100"
    aria-valuemin="0"
    aria-valuemax="100"
  ></div>
</div>
